import { oldSetLanguage } from '../../util/oldLangProvider.ts';
import { getActions } from '../../global/index.ts';
import { callApi } from '../../api/gramjs/index.ts';

const changeLangZhFun = () => {
  const { setSharedSettingOption, } = getActions();
  const langCode = 'zh'
  void oldSetLanguage(langCode, () => {
    setSharedSettingOption({ language: langCode });
  });
}

const tellZhaiXingIsLoginFun = async() => {
  await callApi('justTestFun');
  window.parent.postMessage(
    { type: 'fromIframeMsg', value: 'success' },
    '*'
  )
}

export const cacheDataClearFun = (flag) => {
  if( flag === true ){
    Object.keys(localStorage).forEach(key => key !== 'zxUuid' && localStorage.removeItem(key));
  }else{
    localStorage.clear()
  }
  sessionStorage.clear()
  indexedDB.databases().then(dbs => {
    dbs.forEach(db => {
      console.error('db=>',db);
      if( db.name.includes('account') ){
        indexedDB.deleteDatabase(db.name);
      }
    });
  })
  caches.keys().then(keys => {
    keys.forEach(key => {
      caches.delete(key);
    });
  })
}

const handleMessage = async(event) => {
  if( !['giveAccInfoFromZhaiXing','knowInitOkFromZhaiXing'].includes( event.data.type )){
    return
  }
  console.error('子iframe_收到父window消息',event.data.type)
  if (event.data.type === 'giveAccInfoFromZhaiXing') {
    const { accountKey, accountVal } = event.data
    sessionStorage.setItem( 'accountKey', accountKey)
    sessionStorage.setItem( 'accountVal', accountVal)
    await new Promise(resolve => setTimeout(resolve, 2000))
    localStorage.setItem( accountKey, accountVal)
    sessionStorage.clear()
    sessionStorage.setItem('opening', true)
    await new Promise(resolve => setTimeout(resolve, 250))
    console.error('【 子iframe界面即将触发刷新】');
    window.location.reload()
  }else if (event.data.type === 'knowInitOkFromZhaiXing') {
    const { zxUuid } = event.data
    const oldZxUuid = localStorage.getItem('zxUuid')
    console.error('得到的zxUuid=>',zxUuid);
    console.error('oldZxUuid=>',oldZxUuid);

    //第一次进来，给它设置一个uuid,
    // 第二次进来，如果uuid一样，那么就被视为第二至第n次进来。
    // 如果uuid不一样，那么这个情况就是，子iframe地址一样，父window是新的
    if( !oldZxUuid ){
      localStorage.setItem( 'zxUuid', zxUuid)
      cacheDataClearFun(true)
      console.error('从未进入链接过，这次第一次进来，给它设置一个uuid');
      console.error('【 子iframe界面即将触发刷新】');
      window.location.reload()
    }else if( oldZxUuid != zxUuid ){
      localStorage.setItem( 'zxUuid', zxUuid)
      cacheDataClearFun(true)
      console.error('之前进入链接过，这次第一次进来，给它设置一个uuid');
      console.error('【 子iframe界面即将触发刷新】');
      window.location.reload()
    }else{
      if( sessionStorage.getItem('opening') === 'true' ){
        console.error('子iframe_正在opening状态')
        await new Promise(resolve => setTimeout(resolve, 1000 * 3))
        changeLangZhFun()
        tellZhaiXingIsLoginFun()
        return
      }else if( sessionStorage.getItem('tellingFatherNeedAcc') !== 'true' ){
        console.error('子iframe_告诉父window，需要账号信息')
        sessionStorage.setItem( 'tellingFatherNeedAcc', 'true')
        window.parent.postMessage(
          { type: 'fromIframeMsg', value: 'needAccountInfo' },
          '*'
        )
      }
    }
  }
}

export const zxOpenListener = async() => {
  // 页面关闭或刷新时，监听器会自动销毁，不会额外内存泄漏
  window.addEventListener('message', handleMessage);
  window.parent.postMessage(
    { type: 'fromIframeMsg', value: 'iframeInitSuccess' },
    '*'
  )
  console.log = function () {}
  // console.error = function () {}
  console.warn = function () {}
}
